import createAsyncActionType from '../utilities/createAsyncActionType';

export const SET_INITIAL_TOKEN = createAsyncActionType('SET_INITIAL_TOKEN');


// WEBPACK FOOTER //
// ./src/types/initialTokenTypes.js